<div class="cookie-banner" *ngIf="visible" role="dialog" aria-live="polite">
  <p class="cookie-banner-text" [innerHTML]="'cookie.banner.text' | translate"></p>
  <div class="cookie-banner-actions">
    <app-button size="xsm" color="transparent" border="true" (btnClicked)="refuse()">{{'cookie.banner.refuse' | translate}}</app-button>
    <app-button size="xsm" (btnClicked)="accept()">{{'cookie.banner.accept' | translate}}</app-button>
  </div>
</div>
